import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';

export const getUNFInputDehydrationDefinitions: () => ConditionalRequestDefinition[] =
  () => {
    const vpRelatedDehydrations: ConditionalRequestDefinition[] = [];
    // Erstmal aufbewahren um ein Beispiel zu haben wie die Dehydration bei UNF funktioniert
    //
    // getRelevantVPRoles().forEach((role) => {
    //   const state: UNFVPSchema | undefined = get(useUnfInputStore(), role);
    //
    //   if (state !== undefined) {
    //     vpRelatedDehydrations.push({
    //       if: computed(
    //         () => !state.leistungsumfang.krankenhaustagegeld.enabled,
    //       ),
    //       drop: [
    //         `${role}.leistungsumfang.krankenhaustagegeld.hoehe`,
    //         `${role}.leistungsumfang.krankenhaustagegeld.genesungsgeldInGleicherHoehe`,
    //       ],
    //     });
    //
    //     vpRelatedDehydrations.push({
    //       if: computed(() => !state.leistungsumfang.krankentagegeld.enabled),
    //       drop: [
    //         `${role}.leistungsumfang.krankentagegeld.hoehe`,
    //         `${role}.leistungsumfang.krankentagegeld.tag`,
    //       ],
    //     });
    //   }
    // });

    return [...vpRelatedDehydrations];
  };
